import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

const FILTER_WIDTHS = {
  [RESULTS_TYPES.PUPPIES]: [128, 104, 88, 100, 90],
  [RESULTS_TYPES.BREEDERS]: [128, 162, 90]
};

export default function ExposedFiltersSkeleton({ className, resultsType }) {
  return (
    <div className={classnames('ExposedFiltersSkeleton', className)}>
      <ul className="flex gap-8 overflow-hidden pl6 pl0-md">
        {FILTER_WIDTHS[resultsType].map((width, index) => (
          <li key={index} className="shrink-0">
            <SkeletonBlock key={index} height={42} width={width} />
          </li>
        ))}
      </ul>
    </div>
  );
}

ExposedFiltersSkeleton.propTypes = {
  className: PropTypes.string,
  resultsType: PropTypes.oneOf(Object.values(RESULTS_TYPES)).isRequired
};

ExposedFiltersSkeleton.defaultProps = {
  className: null
};
